export default {
  1: {
    name: "Incubator",
    image:
      "https://storage.mint.bullsandapesproject.com/utils/images/incubator.png",
    description:
      "By merging the DNA of two bulls from the same guild within this highly advanced incubator the Bulls were able to create a magnificent and unique Teen Bull. These Teen bulls are unpredictable, to say the least.",
  },
  2: {
    name: "Merger Orb",
    image:
      "https://storage.mint.bullsandapesproject.com/utils/images/merger-orb.png",
    description:
      "A brave teen had to willingly give up his physical form to become this Merger Orb. These Orbs can be used by four Teens of different guilds to summon a God Bull.",
  },
  20: {
    name: "Meth Machine",
    image: require("../assets/img/utilities/meth_maker.jpg"),
    description:
      "The METH Machine is guild specific and enables Teen Bulls of the same guild, held in the same wallet, to earn 5 methane tokens per day (every 24hrs) for each Teen Bull. You must harvest the Teen Bull generated METH to the ‘METH bank’ daily as these tokens do not compound.",
    guild: "North",
  },
  21: {
    name: "Meth Machine",
    image: require("../assets/img/utilities/meth_maker.jpg"),
    description:
      "The METH Machine is guild specific and enables Teen Bulls of the same guild, held in the same wallet, to earn 5 methane tokens per day (every 24hrs) for each Teen Bull. You must harvest the Teen Bull generated METH to the ‘METH bank’ daily as these tokens do not compound.",
    guild: "South",
  },
  22: {
    name: "Meth Machine",
    image: require("../assets/img/utilities/meth_maker.jpg"),
    description:
      "The METH Machine is guild specific and enables Teen Bulls of the same guild, held in the same wallet, to earn 5 methane tokens per day (every 24hrs) for each Teen Bull. You must harvest the Teen Bull generated METH to the ‘METH bank’ daily as these tokens do not compound.",
    guild: "East",
  },
  23: {
    name: "Meth Machine",
    image: require("../assets/img/utilities/meth_maker.jpg"),
    description:
      "The METH Machine is guild specific and enables Teen Bulls of the same guild, held in the same wallet, to earn 5 methane tokens per day (every 24hrs) for each Teen Bull. You must harvest the Teen Bull generated METH to the ‘METH bank’ daily as these tokens do not compound.",
    guild: "West",
  },
  30: {
    name: "Teen Resurrection",
    image: require("../assets/img/utilities/teen_resurrection.jpg"),
    description:
      "Using this power, you can resurrect a sacrificed Teen from the Underworld. The resurrected Teen must belong to the same guild as the God Bull Power. In order to maintain balance in the BAP universe, you must exchange a teen of the same guild as the resurrected teen. Each newly resurrected Teen generates 5 METH tokens per day and this METH compounds daily; the same as the OG Bulls.",
    guild: "North",
  },
  31: {
    name: "Teen Resurrection",
    image: require("../assets/img/utilities/teen_resurrection.jpg"),
    description:
      "Using this power, you can resurrect a sacrificed Teen from the Underworld. The resurrected Teen must belong to the same guild as the God Bull Power. In order to maintain balance in the BAP universe, you must exchange a teen of the same guild as the resurrected teen. Each newly resurrected Teen generates 5 METH tokens per day and this METH compounds daily; the same as the OG Bulls.",
    guild: "South",
  },
  32: {
    name: "Teen Resurrection",
    image: require("../assets/img/utilities/teen_resurrection.jpg"),
    description:
      "Using this power, you can resurrect a sacrificed Teen from the Underworld. The resurrected Teen must belong to the same guild as the God Bull Power. In order to maintain balance in the BAP universe, you must exchange a teen of the same guild as the resurrected teen. Each newly resurrected Teen generates 5 METH tokens per day and this METH compounds daily; the same as the OG Bulls.",
    guild: "East",
  },
  33: {
    name: "Teen Resurrection",
    image: require("../assets/img/utilities/teen_resurrection.jpg"),
    description:
      "Using this power, you can resurrect a sacrificed Teen from the Underworld. The resurrected Teen must belong to the same guild as the God Bull Power. In order to maintain balance in the BAP universe, you must exchange a teen of the same guild as the resurrected teen. Each newly resurrected Teen generates 5 METH tokens per day and this METH compounds daily; the same as the OG Bulls.",
    guild: "West",
  },
  40: {
    name: "Replenishment",
    image: require("../assets/img/utilities/breeding_recharge.jpeg"),
    description:
      "Using this Breed Replenishment power, you can replenish an OG bull with two, one, or zero breeds to a bull with all three breeds. This God Bull Power is guild specific and will only work on OG Bulls of the same guild.",
    guild: "North",
  },
  41: {
    name: "Replenishment",
    image: require("../assets/img/utilities/breeding_recharge.jpeg"),
    description:
      "Using this Breed Replenishment power, you can replenish an OG bull with two, one, or zero breeds to a bull with all three breeds. This God Bull Power is guild specific and will only work on OG Bulls of the same guild.",
    guild: "South",
  },
  42: {
    name: "Replenishment",
    image: require("../assets/img/utilities/breeding_recharge.jpeg"),
    description:
      "Using this Breed Replenishment power, you can replenish an OG bull with two, one, or zero breeds to a bull with all three breeds. This God Bull Power is guild specific and will only work on OG Bulls of the same guild.",
    guild: "East",
  },
  43: {
    name: "Replenishment",
    image: require("../assets/img/utilities/breeding_recharge.jpeg"),
    description:
      "Using this Breed Replenishment power, you can replenish an OG bull with two, one, or zero breeds to a bull with all three breeds. This God Bull Power is guild specific and will only work on OG Bulls of the same guild.",
    guild: "West",
  },
};
